

import Promotion from "@core/Promotion.js";

export default class OrderReduce extends Promotion{
    constructor(){
        super();
    }

    init(data){
        this._name = "下单立减";
        this._type = data.type;
        this._startTime = data.startTime;
        this._endTime = data.endTime;
        this._terminal = data.terminal;
        this._desc = data.desc;
        this._discountValue = data.discountValue;
    }

    getValue(){
        return this._desc;
    }
}